<template>
  <section class="container">
    <full-page ref="fullpage" :options="options">
      <!-- Sección 1-->
      <div class="section" data-anchor="man1" id="section1man">
        <div class="fp-bg"></div>
        <!--  <v-img :src="image_srcmanTruco" class="img-manTruco" cover></v-img> -->
      </div>

      <!-- Sección 1b-->
      <div class="section" data-anchor="man1b" id="section1bman">
        <div class="slide" id="slideman">
          <div class="fp-bg"></div>
        </div>
      </div>

      <!-- Sección 2-->
      <div class="section" data-anchor="man2" id="section2man">
        <div class="fp-bg"></div>
        <v-container fluid>
          <v-row class="man-texto1">
            <v-col cols="3">
              <img :src="image_srcpunto" class="punto-man" contain />
            </v-col>
            <v-col cols="8">
              <v-row>
                <p class="texto1man">
                  Generamos tendencias que son integrales, especializadas en la
                  cultura y el mundo gastronómico apuntando al interés de un
                  público jóven y diverso.
                </p>
              </v-row>
              <v-row>
                <p class="texto1man">
                  Necesidad de lugares de encuentro dinámicos, salir de la
                  monotonía y lo cotidiano, ciudades latinoamericanas
                  globalizadas, necesidad de una mirada local y lugares de ocio.
                </p>
              </v-row>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-container>
      </div>

      <!-- Sección 3-->
      <div class="section" data-anchor="man3" id="section3man">
        <div class="fp-bg"></div>
        <v-container fluid style="position: relative; height: 100vh;">
          <v-row class="titulos-row-man">
            <v-col cols="3">
              <p class="titulo1man">
                LO QUE NOS MUEVE
              </p>
            </v-col>
            <v-col cols="9"></v-col>
          </v-row>
          <div class="linea-azul"></div>

          <v-row>
            <v-col cols="3"></v-col>
            <v-col cols="8" class="texto2man">
              Nos enfocamos en diseñar para el público objetivo que concentra el
              poder adquisitivo de las ciudades: millenials; ciudadanos entre 20
              y 39 años.
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row>
            <v-col cols="2"></v-col>
            <v-col cols="5"></v-col>
            <v-col cols="5">
              <v-img :src="image_srcman3" contain class="foto-man"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </full-page>
  </section>
</template>

<script>
import store from "../store";

export default {
  data() {
    return {
      image_srcman1: require("../assets/Menu-ManifiestoX.jpg"),
      image_srcman2: require("../assets/man-am.jpg"),
      image_srcman3: require("../assets/foto-manifiesto.jpg"),
      image_srcpunto: require("../assets/punto.png"),
      image_srcmanTruco: require("../assets/Menu-ManifiestoX.jpg"),

      options: {
        licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
        anchors: ["man1", "man1b", "man2", "man3"],
        parallax: true,
        parallaxKey: [
          "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP"
        ],
        // parallaxKey: "7CD7B03B-68104BF5-88FFE8B4-2585F4CC",
        // activation-key for domain colectivoalquimia.cl: Y29sZWN0aXZvYWxxdWltaWEuY2xfcmg0Y0dGeVlXeHNZWGc9bHhi
        scrollingSpeed: "700",
        parallaxOptions: {
          type: "cover",
          percentage: 99,
          property: "translate"
        },
        onLeave: function(origin, destination, direction) {
          if (origin.index == 0) {
            store.commit("esconder");
          } else if (origin.index == 1 && direction == "up") {
            store.commit("mostrar");
          }
        }
      }
    };
  },
  metaInfo: {
    title: "Colectivo Alquimia",
    titleTemplate: "%s | Manifiesto"
  },
  mounted() {
    //var h1 = document.getElementById("section1");
    //var bounding = h1.getBoundingClientRect();
    this.$refs.fullpage.api.moveTo(0);
    store.commit("mostrar");
    window.addEventListener("scroll", this.onScroll, true);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll, true);
  },
  methods: {
    isOnTop() {
      if (this.$refs.fullpage.api.getActiveSection().anchor == "man1") {
        return true;
      } else {
        return false;
      }
    },
    getSection() {
      return this.$refs.fullpage.api.getActiveSection().anchor;
    },
    getSectionIndex() {
      return this.$refs.fullpage.api.getActiveSection().index;
    }
  }
};
</script>

<style>
.container {
  padding: 0px;
  margin: 0px;
  transition: all 0.45s ease-in-out;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}
.fp-bg {
  background-color: rgba(0, 0, 0, 0) !important;
  background-size: cover;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden; /* Chrome, Safari, Opera */
  backface-visibility: hidden;
}
.slide {
  background-color: rgba(0, 0, 0, 0);
  height: 100vh;
}

.section {
  background-color: rgba(0, 0, 0, 0);
  min-width: 100vw;
  min-height: 100vh;
  z-index: -1;
}

#section2man .fp-bg {
  background-color: rgba(0, 0, 0, 0);
  background-size: cover;
  background-position: center 80%;
}
#section3man .fp-bg {
  background-color: #eec7ca !important;
  background-size: cover;
  background-position: center 80%;
}

@media (min-width: 960px) {
  #slideman {
    position: fixed !important;
    background-color: rgba(0, 0, 0, 0);
  }
  #section1man .fp-bg {
    position: fixed !important;
    bottom: 0;
    background-image: url("../assets/Menu-ManifiestoX.jpg");
    background-size: cover;
    margin-bottom: 100vh;
    height: 100vh !important;
    background-position: center 90%;
  }
  #section1bman .fp-bg {
    position: absolute !important;
    background-color: rgba(0, 0, 0, 0) !important;
    top: 0;
    /*background-image: url("../assets/Imagen-inicio2.jpg");*/
    background-size: cover;
    height: 100vh !important;
    margin-top: 100vh;
  }
  .img-manX {
    position: fixed;
    top: 0;
    left: 0;
    height: 0vh;
    width: 0vw;
    z-index: 99999;
  }
  .img-manTruco {
    position: fixed;
    bottom: 0 !important;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 999;
  }
  .primera-imagenman {
    position: relative;
    width: 100vw;
    z-index: 1;
    object-fit: contain;
  }
  .punto-man {
    position: absolute;
    top: 50%;
    left: 10vw;
    height: 10%;
    z-index: 11;
  }
  .linea-azul {
    content: "";
    width: 100vw;
    height: 20px;
    background: #372b5d;
    z-index: 10;
  }
  .foto-man {
    position: relative;
    bottom: 5vh;
    right: 0px;
  }
  .man-texto1 {
    position: relative;
    padding-top: 20vh;
    padding-bottom: 20vh;
  }
  .texto1man {
    font-size: calc(2.5px + 1.61875vw);
    color: #372b5d;
    line-height: 1.5;
    padding-top: 50px;
    padding-bottom: 10px;
    padding-right: 5vw;
  }
  .titulos-row-man {
    margin-top: 0vh;
    padding-top: 5vh;
  }
  .texto2man {
    font-size: calc(4.5px + 1.61875vw);
    color: #372b5d;
    line-height: 1.5;
    padding-top: 50px;
    padding-right: 8vw;
  }
  .texto-italic {
    font-style: italic;
    font-size: calc(4.5px + 1.61875vw);
    font-weight: 400;
    padding-top: 40px;
    line-height: 1.2;
    padding-left: 140px;
  }
  .texto-italic2 {
    font-size: calc(4.5px + 1.61875vw);
    padding-right: 5vw;
    padding-left: 120px;
    font-weight: 400;
    line-height: 1.2;
    padding-top: 240px;
  }
  .titulo1man {
    font-size: calc(20.5px + 1.21875vw);
    line-height: 1;
    margin-left: 5vw;
    font-family: "Source-bold";
    color: #372b5d;
    text-align: right;
    margin-bottom: 0px !important;
  }
  .bajadaman {
    top: 40px;
    display: flex;
    padding-bottom: 0px;
    justify-content: center;
    align-content: center;
    bottom: 0px;
    position: relative;
  }
  .bajada-textoman {
    line-height: 1;
    margin-bottom: 0px;
    justify-content: center;
    font-size: calc(18.5px + 1.01875vw);
    font-family: "Source-bold";
    color: #372b5d;
    text-align: center;
  }
}
@media (max-width: 960px) {
  #section1man .fp-bg {
    position: absolute !important;
    -moz-outline-radius-topleft: 0;
    background-color: #ff919e !important;
    /*background-image: url("../assets/Menu-ManifiestoX.jpg");*/
    background-size: cover;
    margin-bottom: 0vh;
    height: 100vh !important; 
    z-index: 9;
  }
  #section1bman .fp-bg {
    position: absolute !important;
    background-image: url("../assets/Menu-ManifiestoX.jpg");
    top: 0;
    /*background-image: url("../assets/Imagen-inicio2.jpg");*/
    background-size: cover;
    height: 100vh !important;
    background-position: right 10%;
    margin-top: 0vh;
    z-index: 1;
  }
  .img-manX {
    position: fixed !important;
    top: 0;
    right: 0;
    height: 200vh;
    width: 100vw;
    z-index: 99999;
  }
  .img-manTruco {
    position: fixed !important;
    top: 0 !important;
    left: 0;
    height: 200vh;
    width: 100vw;
    z-index: 999;
  }
  .primera-imagenman {
    object-fit: cover;
    position: relative;
    height: 100vh;
    z-index: 1;
  }
  .man-texto1 {
    position: relative;
    padding-bottom: 3vh;
    margin-top: 3vh;
  }
  .punto-man {
    position: absolute;
    top: 20vh;
    height: 4%;
    left: 10vw;
    z-index: 99;
  }
  .texto1man {
    font-size: calc(8.5px + 1.81875vw);
    color: #372b5d;
    padding-right: 5vw;
    padding-left: 3vw;
  }
  .texto2man {
    font-size: calc(8.5px + 1.81875vw);
    color: #372b5d;
    padding: 0px;
    padding-top: 1vh;
  }
  .foto-man {
    margin-top: 5vh;
    left: 0px;
    position: fixed;
  }
  .titulos-row {
    margin-top: 10vh;
  }
  .linea-azul {
    content: "";
    width: 100vw;
    height: 10px;
    background: #372b5d;
    z-index: 10;
  }
  .texto-italic {
    font-style: italic;
    font-size: 9px;
  }
  .texto-italic2 {
    font-style: italic;
    font-size: 9px;
    padding-right: 40px;
    padding-top: 40px;
  }
  .titulo1man {
    font-size: calc(10.5px + 1.81875vw);
    line-height: 1;
    justify-content: flex-end;
    font-family: "Source-bold";
    padding-right: 0px;
    color: #372b5d;
    text-align: right;
    padding-left: 1vw;
    margin-top: 15vh;
    padding-bottom: 0px;
    margin-bottom: 0px !important;
  }
  .bajadaman {
    top: 10px;
    display: flex;
    padding-bottom: 0px;
    justify-content: center;
    align-content: center;
    bottom: 0px;
    position: relative;
  }
  .bajada-textoman {
    line-height: 1;
    margin-bottom: 0px;
    justify-content: center;
    font-size: calc(10.5px + 1.01875vw);
    font-family: "Source-bold";
    color: #372b5d;
    text-align: center;
  }
}
</style>
